import {
	Id,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import { ContactEmailSaveRequest, IContactEmailIndexResource, IContactEmailUpdateResource } from "../types";

const baseKey = "contact-emails";
const markAsPrimaryKey = (id: Id) => [baseKey, `${id}`, "change-primary"];

export const contactEmailService = {
	...withIndexEndpoint<IContactEmailIndexResource>([baseKey]),
	...withShowEndpoint<IContactEmailUpdateResource>([baseKey]),
	...withDestroyEndpoint([baseKey]),
	...withStoreEndpoint<ContactEmailSaveRequest>([baseKey]),
	...withUpdateEndpoint<ContactEmailSaveRequest>([baseKey]),
	markAsPrimary: (id: Id) => axios.put(keyToUrl(markAsPrimaryKey(id))),
	markAsPrimaryKey,
};
